!function(root, factory){

    factory(root, root.app, root.overwatch);

}(this, function(root, app, overwatch){

    var util = overwatch.util;

    function Nav(){

        var open = false;
        var bnet = true;
        var $main = $('nav[role=main]');
        var $mobile = $('nav[role=mobile]');
        var $navbars = $('.navbars');
        var $bnet = $('.nav-mobile-menu-wrap.right');
        var $searchBar = $("#player-search", "nav[role=main]");
        var $searchIcon = $('.nav-search-icon');
        var $searchForm = $('.nav-search-form');
        var $searchField = $('.nav-search-field');
        var $openMenuBtn = null;
        var $openSubMenu = null;

        function isDesktopMode() {
            return util.isSizeAtLeast('md');
        }

        function isHugeDisplay() {
             return util.isSizeAtLeast('xxl');
        }

        function hideBnet(){

            if(bnet && isDesktopMode()){
                bnet = false;
                $navbars.velocity('stop', true);
                $navbars.velocity({ top: -44 }, { duration: 200, easing: 'easeOutCirc' });
            }
        };

        function showBnet(){

            if(!bnet && isDesktopMode()){
                bnet = true;
                $navbars.velocity('stop', true);
                $navbars.velocity({ top: 0 }, { duration: 200, easing: 'easeOutCirc' });
            }
        };

        function expandNav(){
            if(!open){
                open = true;
                $main.velocity('stop', true);
                $main.removeClass('is-contracted');
                $main.addClass('is-expanded');

                if (isHugeDisplay() === false) {
                    $main.velocity({ marginTop: 0, marginLeft: 0, marginRight: 0 }, { duration: 100, easing: 'easeOutCirc', complete: clearInlineStyles });
                }
            }
        };

        function contractNav(){
            if(open){
                open = false;
                $main.velocity('stop', true);
                $main.removeClass('is-expanded');
                $main.addClass('is-contracted');

                if (isHugeDisplay() === false) {
                    $main.velocity({ marginTop: 20, marginLeft: 20, marginRight: 20 }, { duration: 100, easing: 'easeOutCirc', complete: clearInlineStyles });
                }
            }
        };

        function checkNavScroll(){

            var pos = util.posY();
            var scroll = util.scroll();
            var width = util.width();
            var top = 44 + 20;

            if(pos > top && scroll && width >= 768){
                hideBnet()
                expandNav();
                closeSubMenu();
            } else if(pos <= top && scroll && width >= 768){
                showBnet();
                contractNav();
            }
        };

        function openSubMenu(){
            if($openMenuBtn && $openSubMenu){
                $openMenuBtn.toggleClass('m-open', true);
                $openSubMenu.toggleClass('m-open', true);
                $main.toggleClass('is-submenu-open', true);
            }
        };

        function closeSubMenu(){
            if($openMenuBtn && $openSubMenu){
                $openMenuBtn.toggleClass('m-open', false);
                $openSubMenu.toggleClass('m-open', false);
                $openMenuBtn = null;
                $openSubMenu = null;
                $main.toggleClass('is-submenu-open', false);
            }
        };

        function positionSubMenu(){

            if($openMenuBtn && $openSubMenu){
                $openSubMenu.css({ marginLeft: $openMenuBtn[0].getBoundingClientRect().left - $main[0].getBoundingClientRect().left });
            }

        };

        function clearInlineStyles() {
             $main.attr('style', '');
         }

        function toggleSubMenu($btn, $sub){

            if($openMenuBtn && $openMenuBtn[0] == $btn[0] && $openSubMenu && $openSubMenu[0] == $sub[0]){
                closeSubMenu();
            } else {
                closeSubMenu();
                $openMenuBtn = $btn;
                $openSubMenu = $sub;
                positionSubMenu();
                openSubMenu();
            }

        };

        function collapseSearchField() {
            $searchBar.addClass('is-collapsed');
            $main.removeClass('is-search-open');
        }

        function expandSearchField() {
            $searchBar.removeClass('is-collapsed');
            $searchField.focus();
            $main.addClass('is-search-open');
        }

        function initSearchField() {
            $searchIcon.on('click focus', function(event){
                expandSearchField();
            });
            $searchField.on('blur', function(event){
                var searchText = $(this).val();
                if (searchText.length === 0) {
                    collapseSearchField();
                }
            });
            $searchBar.addClass("u-no-transition");
            // We do this here instead of just applying the is-collapsed class
            // in the HTML template so that the search field isn't collapsed
            // for users with JavaScript disabled.
            collapseSearchField();
            //this lookup seems to prevent the animation restarting when the u-no-transition class is removed
            $searchBar.css("width");
            $searchBar.removeClass("u-no-transition");
        }

        function init(){

            checkNavScroll();

            // throttle to 30 fps
            $(root).on('scroll', _.throttle(checkNavScroll, 32));
            $(root).on('resize', _.throttle(function() {
                 if (isHugeDisplay()) {
                     clearInlineStyles();
                 }

                 positionSubMenu();
             }, 32));

            // mobile - set click events for nav items with sub menus
            $mobile.find('.nav-menu').on('click', '.m-has-children', function(event){
                event.preventDefault();
                $(this).toggleClass('m-open').next('.nav-menu').toggleClass('m-open');
            });

            // desktop - set click events for nav items with sub menus
            $main.find('.nav-menu').on('click', '.m-has-children', function(event){
                event.preventDefault();
                var $btn = $(this);
                var $sub = $btn.next('.nav-menu');
                toggleSubMenu($btn, $sub);
            });

            // close sub menu when clicking anywhere outside of it
            $('body').on('click', function(event){
                if ($openSubMenu && event.target !== $openMenuBtn[0] && event.target !== $openSubMenu[0]) {
                    toggleSubMenu($openMenuBtn, $openSubMenu);
                }
            });

            // handle menu toggles for bnet nav
            $('.js-bnet').on('click', function(event){
                event.preventDefault();
                $bnet.toggleClass('out', true);
                $('#nav-blackout').one('click', function(event){
                    event.preventDefault();
                    $bnet.toggleClass('out', false);
                });
            });

            // handle search field expansion/collaps
            initSearchField();
        };

        init();

        this.hideBnet = hideBnet;
        this.showBnet = showBnet
        this.expandNav = expandNav;
        this.contractNav = contractNav;

    };

    app.extend({ nav: new Nav() });

    return app.nav;

});
